import "./our-process.scss";
import HeadlineSection from "../../components/headline-section";
import ProcessCard from "../process-card";
import process1 from "../../assets/home/c.png";
import process2 from "../../assets/home/p.png";
import process3 from "../../assets/home/r.png";


const OurProcess = () => {
  return (
      <div className="our-process">
        <div className="all-process">
            <ProcessCard processImage={process1}
            processTitle={"شروط ومعايير "}
            />
            <ProcessCard processImage={process2}
            processTitle={"سياسات الدعم "}
            />
            <ProcessCard processImage={process3}
            processTitle={"طلب الدعم "}
            />
        
        </div>
        
      </div>
  );
};

export default OurProcess;